import { useHistory } from "react-router-dom";
import React, { useState } from "react";
import { TextTruncate } from "utility/CommonService";
import { EditEntityModal } from "../Modals/EditEntityModal";

import {
  ACCESS_LEVEL,
  ENTITY_COLORS,
  ENTITY_TYPES,
} from "utility/constants/constants";
import {
  updateProject
} from "redux/actions/ProjectsActions";
import { updateDataSet } from "redux/actions/DataSetActions";
import EntityInfo from "./EntityInfo";
import swal from "sweetalert";
import * as datasetActions from "../../../redux/actions/DataSetActions";
import * as commonService from "../../../utility/CommonService";
import * as projectsActions from "../../../redux/actions/ProjectsActions";
import { useDispatch } from "react-redux";
import { updateWorkflow } from "redux/actions/WorkflowActions";
import { EntityMenu } from "components/shared/EntityMenu/EntityMenu";

export const Row = ({entity, entityType, accessLevel, isSharedWithMe, onShare }) => {
  const dispatch = useDispatch()
  const history = useHistory();
  const [showEditModal, setShowEditModal] = useState(false)

  const deleteEntity = (entity, entityType) => {
    let entityName = ""

    if (entityType === ENTITY_TYPES.PROJECT_V2) {
      entityName = "projects"
    } else if (entityType === ENTITY_TYPES.DATASET) {
      entityName = "datasets"
    } else if (entityType === ENTITY_TYPES.WORKFLOW) {
      entityName = "workflows"
    }

    swal({
      text: `Are you sure you want remove this from the ${entityName} page?`,
      className: "logout-alert-modal",
      buttons: [true, "Delete"],
    }).then((result) => {
      if (result && entityType === ENTITY_TYPES.PROJECT_V2) {
        dispatch(projectsActions.deleteProject({id: entity.id})).then((res) => {
          if (res.value && res.value.success) {
            commonService.forSuccess("Project Deleted!", "Success");
          }
        })
      } else if (result && entityType === ENTITY_TYPES.DATASET) {
        dispatch(datasetActions.deleteDataSetObject({
          body: {path: entity.path},
          id: entity.id
        })).then((res) => {
          if (res.value && res.value.success) {
            commonService.forSuccess("Dataset Deleted!", "Success")
          }
        })
      }
    })
  };

  let urlPrefix = ""
  let updateEntity = null
  let entityColor = ""

  if (entityType === ENTITY_TYPES.PROJECT_V2) {
    urlPrefix = '/projectsv2'
    updateEntity = updateProject
    entityColor = ENTITY_COLORS.PROJECT_V2
  } else if (entityType === ENTITY_TYPES.DATASET) {
    urlPrefix = '/datasets'
    updateEntity = updateDataSet
    entityColor = ENTITY_COLORS.DATASET
  } else if (entityType === ENTITY_TYPES.WORKFLOW) {
    urlPrefix = '/workflows'
    updateEntity = updateWorkflow
    entityColor = ENTITY_COLORS.WORKFLOW
  }

  return (
    <>
      <div
        onClick={() => history.push(`${urlPrefix}/${entity.id}`)}
        className="project_row d-flex flex-column"
        style={{borderLeftColor: entityColor}}
      >
        <div className="row flex-grow-1">
          <div className="col-sm-4">
            <div className="project_text_left">
              <div className="project_title" to={`${urlPrefix}/${entity.id}`}>{entity.name}</div>
              <p className="word-break">
                {TextTruncate({
                  text: entity.description, limit: 75,
                })}
              </p>
            </div>
          </div>
          <div className="col-sm-8">
            <div className="project_text_right">
              <div className="show_tool">
                {
                  accessLevel === ACCESS_LEVEL.EDIT && (
                    <EntityMenu
                      onEdit={() => setShowEditModal(true)}
                      onShare={() => onShare && onShare(entity, entityType)}
                      onDelete={() => deleteEntity(entity, entityType)}
                    />
                  )
                }
              </div>
                <EntityInfo entity={entity} isSharedWithMe={isSharedWithMe} />
            </div>
          </div>
        </div>
      </div>
      <EditEntityModal
        entity={entity}
        entityType={entityType}
        updateEntity={updateEntity}
        showModal={showEditModal}
        setShowModal={setShowEditModal}
      />
    </>

  );
};

export default Row;
